
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/main.css'
import '@/assets/iconfont/iconfont.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Define Vue production feature flags
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

const app = createApp(App)

// Register Element Plus icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
import  zhCn from 'element-plus/es/locale/lang/zh-cn'

// 应用初始化时加载用户信息
const initializeApp = async () => {
  try {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    const userStr = localStorage.getItem('user');
    const role = localStorage.getItem('role');

    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        // 更新Vuex store中的用户信息
        store.commit('setToken', token);
        store.commit('setRefreshToken', refreshToken);
        store.commit('setUser', user);
        store.commit('setRole', role);
      } catch (e) {
        console.error('Failed to parse user data:', e);
        // 如果解析失败，清除可能损坏的存储数据
        localStorage.removeItem('user');
      }
    }
  } catch (error) {
    console.error('Error during app initialization:', error);
  }
}

// 在挂载应用前初始化
await initializeApp();

app.use(store)
app.use(router)
app.use(ElementPlus, {locale: zhCn})

app.mount('#app')
